
export const sFechaPublicacion = '2026-02-10T11:32:57.5263931-06:00';
export const sVersion = 'vf1.1.602101132';
            